<template>
  <router-view></router-view>
</template>

<script>
export default {
    name: "oi-wrapper"
};
</script>

<style>
</style>